import React from 'react'
import { FaRegCopyright } from "react-icons/fa6";
import { LuYoutube } from "react-icons/lu";
import { FaTwitter } from "react-icons/fa6";
import { BsFacebook } from "react-icons/bs";
import { FaInstagram } from "react-icons/fa";
import { Link } from 'react-router-dom';


const Footer = () => {
    return (
        <div className='bg-primary bg-gradient-to-t from-blue-900 to-primary md:h-[350px] lg:h-[350px] h-auto flex  md:flex-row lg:flex-row flex-col max-md:items-start items-center justify-around w-full'>
            <div className='flex flex-col justify-center items-start md:gap-16 gap-2 p-5 max-md:px-6'>
                <p className='text-blue-100 font-medium'>my credit report.in</p>
                <div className='flex gap-2 text-blue-100 justify-center items-center text-xl md:text-2xl font-medium'> <FaRegCopyright className='bg-transparent text-blue-100' /><p>2023 myCreditReport.in</p></div>
            </div>
            <div className='flex md:flex-row lg:flex-row flex-col md:items-center lg:items-center items-start gap-5 md:gap-10 p-5 max-md:px-6'>
                <div className='flex flex-col justify-center items-start gap-2 md:gap-3 text-blue-100'>
                    <Link to='/about'><p>About US</p></Link>
                    <p>Contact US</p>
                    <p>Privacy Policies</p>
                    <Link to='/terms'><p>Terms of Services</p></Link>
                </div>
                <div className='flex flex-col justify-center items-start  mt-[3%] gap-2 md:gap-5 max-md:pt-5 '>
                    <p className='text-blue-100'>Follow US</p>
                    <div className='flex text-blue-100 gap-3'>
                        <LuYoutube className='w-[30px] h-[30px] text-blue-100' />
                        <FaTwitter className='w-[30px] h-[30px]' />
                        <BsFacebook className='w-[30px] h-[30px]' />
                        <FaInstagram className='w-[30px] h-[30px]' />

                    </div>


                </div>

            </div>
        </div>
    )
}

export default Footer